<script>
import { QOptionGroup } from 'quasar'
import { mergeData } from 'vue-functional-data-merge'
import enums from '@/lib/enums'
import store from '@/store'
import _ from 'lodash'

function computeOptions (props) {
  console.log('computeOptions11', props)
  if (props.options) {
    return props.options
  } else if (props.enum) {
    return enums[props.enum].items
  } else if (props.word) {
    return store.getters['bis/word/getWordsOptionsByType'](props.word)
  } else if (props.dic) {
    return store.getters['bis/dic/modelsOptions'](props.dic)
  }
}

function computeLabel (props) {
  if (props.label) {
    return props.label
  } else if (props.enum) {
    return enums[props.enum].label
  } else if (props.word) {
    return store.getters['bis/word/getWordLabelByType'](props.word)
  } else if (props.dic) {
    return store.getters['bis/dic/modelLabel'](props.dic)
  }
}

// function computeValue (props) {
//   return props.value ?? []
// }

export default {
  functional: true,
  props: {
    inline: {
      type: Boolean,
      default: true
    },
    options: Array,
    label: String,
    enum: String,
    word: String,
    dic: String,
    nullAsAll: Boolean,
    value: {
      require: true
    }
  },
  // 由于需要mounted 预先加载loadWords, 故
  render (createElement, { props, data, children }) {
    const computedOptions = computeOptions(props)
    console.log('computedOptions', props, computedOptions)
    const computedLabel = computeLabel(props)
    let computedValue = props.value
    if (props.nullAsAll && _.isNil(props.value)) {
      computedValue = computedOptions?.map(item => item.value)
      data.on?.input && data.on.input(computedValue)
    }
    return createElement(QOptionGroup, mergeData({
      props: {
        ...props,
        options: computedOptions,
        label: computedLabel,
        value: computedValue
      }
    }, data), children)
  }
}
</script>
